import React from 'react';
import withView from "../../../../cmn/docAutomation/withView";
import FormLink from '../../../../../library/form/components/FormLink';
import FormInput from '../../../../../library/form/components/FormInput';
import FormRichText from '../../../../../library/form/components/FormRichText';
import FormSlider from '../../../../../library/form/components/FormSlider';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormTitle from '../../../../../library/form/components/FormTitle';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormSearchButton from '../../../../../library/form/components/FormSearchButton'
import coreSetting from '../../../../../helper/coreSetting';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import { UiGridColTwo, UiCol, UiRow, UiClear } from "../../../../../library/layout/Index";

const ProdShorthand = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ actionParam: { showModeID: 'sh' }, formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '400px' }}
            formStyle={{ width: '800px', height: '500px' }} formTitle={<FormTitle formObject={formObject} value="Order Details" />}
        >
            <UiClear></UiClear>
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "projectType1" }} value="Order Category" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "projectType1", 
                                actionId: "refresh", actionName: "prodHeader", actionParam: { actionType: "updateProjectType1" },
                                acMethod: "CategoryDetail", acDepCtrl: { 'dparam': '%dataList.valLCat' } }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{paramName:"targetItemSelector"}}>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemName" }} value="Target Item" />
                            </span>
                            <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink'
                                text={<SarasTrans value="Select Target" />} placeHolder="Barcode / Id..."
                                action={{ actionId: "refresh", actionName: "prodHeader", actionParam: {changeitem: 1} }}
                                className='uiActionButton uiSpacerH5'
                            />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemName" }} value="Item Name" />
                            </span>
                            <FormLink useValF={1} formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                action={{ paramName: "targetItemName", actionId: "show", actionName: "itemComp" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty" }} value="Qty" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "qty" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requiredDate" }} value="Required Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "dp", paramName: "requiredDate" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "startDate" }} value="Plan Start Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "dp", paramName: "startDate" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "finishDate" }} value="Plan Finish Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "dp", paramName: "finishDate" }} />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bomName" }} value="BOM" />
                            </span>
                            <FormInput formObject={formObject} rowKey=""
                                action={{
                                    InputType: "ac", paramName: "bomName", acMethod: "TargetItemBom",
                                    acDepCtrl: { 'dparam': '%dataList.valLDT', 'tdtId': '%dataList.tdtId', 'tdId': '%dataList.tdId' },
                                    actionParam: { }
                                }} className='uiInput' style={{ width: '220px' }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "projectType2" }} value="Ord Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "projectType2", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="Customer" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "profile", acMethod: "ProfileName", acDepCtrl: { 'dparam': '%dataList.valLDT', reqPerm: 1} }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budget" }} value="Budget" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "budget" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reserve" }} value="Reserve" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "reserve", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': '%dataList.valLCat' } }}
                            />
                            <span>%</span>
                        </li>
                        <li>
                            <span style={{ width: "125px" }} className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priority" }} value="Priority" />
                            </span>
                            <div className="uiInline">
                                <FormSlider formObject={formObject} rowKey="" action={{ paramName: "priority", datalist: coreSetting.priorityList.Priority }} />
                            </div>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "queue" }} value="Queue" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "queue" }} />
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiClear></UiClear>
            <UiRow>
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comments" }} value="Comments" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="82"
                            action={{ paramName: "comments" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "specialInst" }} value="Special Instructions" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="82"
                            action={{ paramName: "specialInst" }}
                        />
                    </li>
                </ul>
            </UiRow>
        </FormDialog>
    )
}

export default withView(ProdShorthand, "prodComp", "budgetAction,budgetHeader");
